import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from '../Spacing/VerticalSpacer'

const Root = styled(VerticalSpacer)`
  text-align: center;
`

interface Props {
  className?: string;
  icon?: React.ReactNode;
  title?: string;
  text?: React.ReactNode;
}

function IconedCallout({ className, icon, title, text }: Props) {
  return <Root gap={16} className={className}>
    {icon}
    <VerticalSpacer gap={8}>
      {title && <Heading variant="heading5">{title}</Heading>}
      {text && <BodyText variant="large" as="p">{text}</BodyText>}
    </VerticalSpacer>
  </Root>
}

export default IconedCallout
